if (window.location.pathname.startsWith("/login")) {
$("#loginForm").on("submit", function(e) {
    e.preventDefault();
    const btn = new LoadingButton($(".loginButton"));
    const username = $("#username").val();
    const password = $("#password").val();
    btn.start();
    const csrftoken = $("[name=csrfmiddlewaretoken]").val();
    if (!username || !password) {
        showAlert("username and password are required");
        btn.stop();
        return;
    }
    if (password.length < 8){
        loginAlert("Use at least 8 characters for password");
        btn.stop();
        return;
    }
    
    $.ajax({
        url: "",
        method: "POST",
        data: {
            username: username,
            password: password
        },
        headers: {
            "X-CSRFToken": csrftoken
        },
        success: function(result) {
            btn.stop("Login Successful!", "success");
            window.location.href = result.redirect_url;
        },
        error: function(xhr) {
            btn.stop();
            let errorMsg = "Login failed.";
            if (xhr.responseJSON && xhr.responseJSON.error) {
                errorMsg = xhr.responseJSON.error;
            }
            loginAlert(errorMsg);
        }
    });
});
function loginAlert(message) {
    const alert = $('#alert');
    const alertMessage = $('#alert-message');
    
    if (message) {
        alertMessage.text(message);
    }
    
    alert.removeClass('alert-hidden').addClass('alert-visible');
}

$('.close-alert').on('click', function() {
const alert = $('#alert');
    alert.removeClass('alert-visible').addClass('alert-hidden');
});



};

$(document).on('click', '#togglePassword', function() { 
    const passwordInput = $('#password');
    const icon = $(this).find('i');
    
    if (passwordInput.attr('type') === 'password') {
        passwordInput.attr('type', 'text');
        icon.removeClass('bi-eye-slash-fill').addClass('bi-eye-fill');
    } else {
        passwordInput.attr('type', 'password');
        icon.removeClass('bi-eye-fill').addClass('bi-eye-slash-fill');
    }
});